import { useEffect } from "react";

/**
 * Adds the `.in` class to anything tagged `.reveal` once it scrolls into view.
 * Mirrors the static site's behavior. Runs once on mount and again whenever new
 * `.reveal` nodes appear in the tree (cheap — IntersectionObserver is observer-based).
 */
export function useScrollReveal() {
  useEffect(() => {
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll(".reveal").forEach((el) => el.classList.add("in"));
      return;
    }
    const obs = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            obs.unobserve(e.target);
          }
        }),
      { rootMargin: "0px 0px -10% 0px", threshold: 0.05 }
    );
    document.querySelectorAll(".reveal:not(.in)").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}
